import script from "./PaymentMethodForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethodForm.vue?vue&type=script&setup=true&lang=js"

import "./PaymentMethodForm.vue?vue&type=style&index=0&id=20a76607&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20a76607"]])

export default __exports__